import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextAlignmentJustify24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTextAlignmentJustify24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M20.244 7.5a.75.75 0 0 0 0-1.5H3.775a.75.75 0 0 0 0 1.5zm0 7a.75.75 0 0 0 0-1.5H3.775a.75.75 0 0 0 0 1.5zm.75-4.25a.75.75 0 0 1-.75.75H3.775a.75.75 0 0 1 0-1.5h16.469a.75.75 0 0 1 .75.75M20.25 18a.75.75 0 0 0 0-1.5H3.775a.75.75 0 0 0 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextAlignmentJustify24);
